const PracticeUserHub = {
    route: "/hubs/practice-user",
    events: {
        UserDeleted: "UserDeleted"
    }
}

export default PracticeUserHub;